export default {
    en: {
        // sidebar
        Dashboard: "Dashboard",
        Setting: 'Setting',
        Report: 'Reports',
        Booking: 'Booking',
        Marketing: 'Marketing',
        Product: 'Products',
        'Loyalty Members': 'Loyalty Members',
        'Order Management': 'Order Management',
        // 'Payment': 'Payment',
        'Subscription': 'Subscription',
        'POS Simulator': 'POS Simulator',
        'Stripe Reader': 'Stripe Reader',
        // end sidebar

        // GLOBAL
        name: 'Name',
        status: 'Status',
        action: 'Action',
        logout: 'Logout',
        language: 'Language',
        Type: "Type",
        Count: "Count",
        Image: "Image",
        All: "All",
        Time: "Time",
        RUN: "RUN",
        ID: "ID",
        Display_Period: "Display Period",
        // END GLOBAL

        // subscription
        select: 'Select',
        package: 'Package',
        price: 'Price',
        nextBiling: 'Next Biling',
        dueAmount: 'Due Amount',
        paymentStatus: 'Payment Status',
        // status: 'Status',
        // action: 'Action',
        // end subscription

        // PAYMENT
        // name: 'Name',
        merchantCode: 'Merchant Code',
        stripeAccount: 'Stripe Account',
        accessCode: 'Access Code',
        merchantID: 'Merchant ID',
        posId: 'POS ID',
        viewPayout: 'view payout',
        // END PAYMENT

        // LOYALTY  MEMERS
        LoyaltyMemberlist: "LOYALTY MEMBER LIST",
        selectTier: "Select Tier",
        selectGender: "Select Gender",
        bulkAction: "BULK ACTION",
        download: "DOWNLOAD",
        // ID: "ID",
        phoneNo: "Phone No",
        // name: "Name",
        email: "Email",
        DOB: "DOB",
        gender: "Gender",
        joinDate: "Join Date",
        lastPurchase: "Last Purchase",
        lastActive: "Last Active",
        // status: "Status",
        // action: "Action",
        // END LOYALTY  MEMERS

        // Products
        PRODUCTS_MERCHANDISES_LIST: "PRODUCTS & MERCHANDISES LIST",
        ADD_PRODUCT_MERCHANDISE: "ADD PRODUCT/MERCHANDISE",
        // Type: "Type",
        SKU: "SKU",
        // Image: "Image",
        Name: "Name",
        Price: "Price",
        Stock: "Stock",
        // status: "Status",
        // action: "Action",
        ADD_GROUP: "ADD GROUP",
        Group_ID: "Group ID",
        Group_Name: "Group Name",
        Group_Description: "Group Description",
        // status: "Status",
        // action: "Action",
        // End Products

        // Marketing
        OVERALL_PERFORMANCE: "Overall Performance",
        Total_Rewards_Used: "Total Rewards Used",
        Average_Spending_per_Rewards: "Average Spending per Rewards",
        Total_Revenue_from_Rewards: "Total Revenue from Rewards",
        REWARDS_CAMPAIGN: "REWARDS CAMPAIGN",
        // Count: "Count",
        Show: "Show",
        // All: "All",
        Active: "Active",
        Past: "Past",
        Deactive: "Deactive",
        Campain_Title: "Campain Title",
        Rewards: "Rewards",
        // Type: "Type",
        Duration: "Duration",
        Email_Sent: "Email Sent",
        SMS_Sent: "SMS Sent",
        Used: "Used",
        Revenue: "Revenue",
        // status: "Status",
        // action: "Action",
        // end Marketing

        // slide show
        SLIDES_SHOW_REPORT: "Slides Show Report",
        // Time: "Time",
        // RUN: "Run",
        // Count: "Count",
        Image_ID: "Image ID",
        Image_File: "Image File",
        // Image: "Image",
        Who_can_see_this_image: "Who can see this image",
        // Display_Period: "Display Period",
        Created_Date: "Created Date",
        Creator: "Creator",
        // status: "Status",
        EXPORT_TO_EXCEL: "EXPORT TO EXCEL",
        // end slide show

        // Voucher Redemption
        Voucher_Status: "Voucher Status",
        // All: "All",
        Redeemable: "Redeemable",
        Redeemed: "Redeemed",
        // Time: "Time",
        Search: "Search",
        Voucher_Type: "Voucher Type",
        Discount_Amount: "Discount Amount",
        Member_Gender: "Member Gender",
        Select_gender: "Select gender",
        // download: "Download",
        // Count: "Count",
        // RUN: "RUN",
        Columns: "Columns",
        Row_No: "Row No",
        Voucher_Name: "Voucher Name",
        Voucher_Code: "Voucher Code",
        Discount: "Discount",
        Bill_Total: "Bill Total",
        Member_Name: "Member Name",
        Member_ID: "Member ID",
        Member_Email: "Member Email",
        Member_Mobile: "Member Mobile",
        Issue_Date: "Issue Date",
        Redeem_Date: "Redeem Date",
        // end Voucher Redemption

        // TOP UP
        Top_Up_Amount: "Top Up Amount",
        Payment_Amount: "Payment",
        Paid_Amount_Expiry: "Expiry",
        Bonus_Amount: "Bonus",
        Bonus_Expiry: "Bonus Expiry",
        // action: "Action",
        // END TOP UP

        // BRANCHES
        // ID: "ID",
        Branch_Name: "Branch Name",
        Physical_Branch_Name: "Physical Branch Name",
        Virtual_Branch_Name: "Virtual Branch Name",
        Sale_Channel_Name: "Sale Channel Name",
        Address: "Address",
        Operating_Hours: "Operating Hours",
        // status: "Status",
        // action: "Action",
        // END BRANCHES

        // SLIDES
        Slider_Images: "Slider Images",
        Image_Sequence: "Image Sequence",
        Recommended_Size_Landing_Page: "Recommended size: 1080 × 1350 px (4:5)",
        Recommended_Size_Banner: "Recommended size: 1200 × 600 px (2:1)",
        Recommended_Size_Product_Image: "Recommended size: 800 × 800 px (1:1)",
        Recommended_Size_Category_Image: "Recommended size: 400 × 400 px (1:1)",
        Upload_image: "Upload image",
        Who_can_see_this_slide: "Who can see this slide",
        // Display_Period: "Display Period",
        From: "From",
        Always_Display: "Always Display",
        Destination_link: "Destination link (User will be directed to this link when click on image from Member portal)",
        VIP: "VIP",
        LEVEL_1: "LEVEL 1",
        LEVEL_2: "LEVEL 2",
        PLATINUM: "PLATINUM",
        // END SLIDES

        // TIER
        Tier_Name: "Tier Name",
        Description: "Description",
        Show_tier_description_in_member_portal: "Show tier description in member portal",
        Show_tier_condition_in_member_portal: "Show tier condition in member portal",
        Condition_to_achieve_tier: "Condition to achieve tier",
        Share_full_profile: "Share full profile",
        Spending: "Spending",
        Duration_of_membership : "Duration of membership ",
        Condition_to_maintain_tier: "Condition to maintain tier",
        Cashback_Rule: "Cashback Rule",
        Point_Rule: "Ponit Rule",
        Standard_Rule: "Standard Rule",
        Superior_Rule: "Superior Rule",
        Welcome_Benefit: "Welcome Benefit",
        Voucher: "Voucher",
        Direct_Cashback: "Direct Cashback",
        Direct_Point: "Direct Point",
        Birthday_Benefit: "Birthday Benefit",
        Extra_Cashback: "Extra Cashback",
        Extra_Point: "Extra Point",
        SAVE : "SAVE ",
        DELETE: "DELETE",
        Tier_Badge: "Tier Badge",
        UPLOAD_ICON: "UPLOAD ICON",
        Upload_icon_minumum_150_150: "Upload icon minumum 150 x 150",
        VIP_TIER: "VIP TIER",
        PLATINUM_TIER: "PLATINUM TIER",
        save: "save",
        delete: "delete",
        // END TIER

        // Settings - Voucher set
        // ID: "ID",
        Title: "Title",
        // Image: "Image",
        // Type: "Type",
        Exchange_Value: "Exchange Value",
        Total: "Total",
        Sold: "Sold",
        Issued: "Issued",
        Number_Of_Vouchers: "Number Of Vouchers",
        Total_Rev: "Total Rev",
        // Used: "Used",
        Expiry_Date: "Expiry Date",
        // status: "Status",
        // action: "Action",
        // END Settings - Voucher set

        // Settings - Discount
        Rewards_Used: "Rewards Used",
        // Average_Spending_per_Rewards: "Average Spending per Rewards",
        // Total_Revenue_from_Rewards: "Total Revenue from Rewards",
        // ID: "ID",
        // Title: "Title",
        Code: "Code",
        // Used: "Used",
        // Revenue: "Revenue",
        // action: "Action",
        // END Settings - Discount

        // Settings - Cashback
        STANDARD_RULE: "STANDARD RULE",
        Hours: "Hours",
        Pending_time_before_cashback_can_be_redeemed: "Pending time before cashback can be redeemed",
        Pending_time_before_point_can_be_redeemed: "Pending time before point can be redeemed",
        Expiry_of_each_cashback_amount: "Expiry of each cashback amount",
        Expiry_of_each_point_amount: "Expiry of each point amount",
        Rebate: "Rebate",
        Save: "Save",
        Delete: "Delete",
        Cashback: "Cashback",
        Point: "Point",
        No_end_date: "No end date",
        SUPERIOR_RULE: "SUPERIOR RULE",
        Rule_Name: "Rule Name",
        Spend_Every: "Spend Every",
        Spend_Minimum: "Spend Minimum",
        Exchange: "Exchange",
        // END Settings - Cashback

        // Settings - General
        Merchant_Info: "Merchant Info",
        Merchant_ID: "Merchant ID",
        Merchant_Code: "Merchant Code",
        Company_Email: "Company Email",
        Finance_Email: "Finance Email",
        Finance_Mobile: "Finance Mobile",
        Contact_Infomation: "Contact Infomation",
        Contact_Emails: "Contact Emails(for member's queries)",
        Free_Text: "Free Text",
        Terms_Conditions: "Terms & Conditions",
        Privacy_Policy: "Privacy Policy",
        Terms_Conditions_Donation: "Terms & Conditions(Donation)",
        Merchant_Appearance: "Merchant Appearance",
        Merchant_Logo: "Merchant Logo",
        Logo_Theme2: "Logo Theme 2",
        Main_Theme2_Color: "Main Theme 2 Colour",
        // KSK063 Kiosk Appearance
        Kiosk_Appearance: "Appearance",
        Kiosk_Appearance_Hint: "Click a highlighted element in the preview to change its colours.",
        Kiosk_Pick_Colours: "Pick colours",
        Kiosk_Use_Kiosk: "Use kiosk",
        Kiosk_Page_Landing: "Landing",
        Kiosk_Page_Menu: "Menu",
        Kiosk_Page_Cart: "Cart",
        Kiosk_Page_Payment: "Payment",
        Kiosk_Page_Rewards: "Rewards",
        Kiosk_Custom_Colours: "Custom colours",
        Kiosk_No_Custom_Colours: "Every element uses the theme colour.",
        Kiosk_Reset_All: "Reset all to theme colours",
        Kiosk_Use_Theme_Colour: "Use Theme Colour",
        Kiosk_Set_Custom_Colour: "Set Custom Colour",
        Kiosk_Outline: "Outline",
        Kiosk_Font: "Font",
        Kiosk_Accent: "Accent",
        Kiosk_Apply: "Apply",
        Kiosk_Cancel: "Cancel",
        Kiosk_Unsaved: "Unsaved changes. Click Save to keep them.",
        Kiosk_Saved: "Kiosk colours saved.",
        Kiosk_Select_Channel: "Select a sale channel to preview its kiosk.",
        // KSK117 kiosk background colours
        Kiosk_Background_Colours: "Background colours",
        Kiosk_Bg_Header: "Header (ordering, cart and payment pages)",
        Kiosk_Bg_Category: "Menu category background",
        Kiosk_Bg_Menu: "Menu listing background",
        Kiosk_Bg_Default: "Default",
        Kiosk_Bg_Reset: "Use default background",
        Primary_Button_Color: "Primary Button Colour Theme2",
        Loyalty_App_Theme_Color: "Loyalty App Theme Color (background)",
        Loyalty_App_Button_Color: "Loyalty App Button Color",
        Loyalty_App_Button_Text_Color: "Loyalty App Button Text Color",
        Loyalty_App_Text_Header_Color: "Loyalty App Text Header Color",
        Member_App_Theme_Color: "Member App Theme Color",
        Member_App_Theme_Color_Default: "Default",
        Reset_To_Default: "Reset to default",
        Member_Login_Background: "Login Background",
        Member_Login_Background_Hint: "Shown behind the logo on the member app's sign-in page. Leave empty to keep the default background.",
        Member_Login_Background_Format: "png, jpg/jpeg or webp",
        Outlet_List_Header: "Outlet List Header",
        Outlet_List_Header_Hint: "Shown at the top of the outlet list page (/physical-branch/order), above the outlets. Leave empty to show no header.",
        Recommended_Size_Outlet_List_Header: "Recommended size: 1080 × 1440 px (3:4)",
        // UPLOAD_ICON: "UPLOAD ICON",
        Upload_image_maximum_2M: "Upload image maximum 2M",
        Options: "Options",
        POS_Version: "POS Version",
        Allow_set_up_membership_tiering: "Allow set up membership tiering",
        Visits: "Visits",
        Allows_displaying_membership_spending: "Allows displaying membership spending",
        Allows_displaying_lifetime_earn_cashback: "Allows displaying lifetime earn cashback",
        Allows_displaying_redeemed_cashback: "Allows displaying redeemed cashback",
        Cashback_by_subtotal: "Calculate cashback base on subtotal",
        only_allow_existing_member_moo_login: "Only allow existing members to login",
        allow_show_apply_voucher: "Allow show apply voucher",
        automatically_extend_expired_wallet_balance_after_a_top_up: "Automatically extend expired wallet balance after a top-up",
        show_topup_button_on_home: "Show Top-up button on member Home",
        Member_donation_transaction_history: "Allow displaying member's donation in Transaction History screen",
        Otp_test_mode: "OTP test mode",
        // Otp test mode: "Otp test mode",
        Member_Special_Rewards: "Member Special Rewards",
        Reward_per_transaction: "Reward per transaction",
        Collect_cashback_and_point: "Allow members to earn cashback/points when orders are paid by wallet",
        Profile_sharing_reward: "Profile sharing reward(Voucher sent when user inputs or shares profile to merchant)",
        Friend_inviting_reward: "Friend inviting reward(Voucher sent when user's friend sign up)",
        SMS_Setup: "SMS Setup",
        Character_count:"Character count",
        Notifications: "Notifications",
        // Notification: "Notification",
        Topup: "Topup",
        Deduction_From_Wallet: "Deduction From Wallet",
        Earn_Cashback: "Earn Cashback",
        In_App: "In-App",
        Email: "Email",
        SMS_and_WA: "SMS & WhatsApp",
        Airwallex_checkout_failed: "Could not open the payment page, please try again",
        Notification_Content: "Notification Content",
        // Settings - General

        // POS simulator
        POS_Transaction: "POS Transactions",
        Update_POS_Transaction: "Update POS Transaction",
        Phone_Number: "Phone Number",
        By_Total_Amount: "By Total Amount",
        By_product: "By product",
        Total_Amount: "Total Amount",
        Discount_Code: "Discount Code",
        // Voucher_Code: "Voucher Code",
        Branch: "Branch",
        Staff: "Staff",
        Deduct_from_Wallet: "Deduct from Wallet",
        Payment_Amount_Topup: "Payment Amount",
        Top_Up: "Top Up",
        // Phone_Number: "Phone Number",
        Branch_Id: "Branch Id",
        // Staff: "Staff",
        // Top_Up_Amount: "Top Up Amount",
        Top_Up_Method: "Top Up Method",
        Cashback_Adjustment: "Cashback Adjustment",
        // Phone_Number: "Phone Number",
        // Branch_Id: "Branch Id",
        // Staff: "Staff",
        // Total_Amount: "Total Amount",
        Add_more_payment_amount: "Add more payment amount",
        Receipt_Total: "Receipt Total",
        Sub_Total: "Sub Total",
        Total_Before_Tax: "Total Before Tax",
        GST: "GST",
        Cess: 'Cess',
        Service_Charge: 'Service Change',
        Take_Away_Charge: 'Take Away Charge',
        Payment: "Payment",
        Wallet_Balance : "Wallet Balance",
        Paid_Topup: "Paid Topup",
        Topup_Bonus: "Topup Bonus",
        // Cashback: "Cashback",
        Address_1: "Address 1",
        Address_2: "Address 2",
        // Email: "Email",
        // Name: "Name",
        Tier: "Tier",
        Remarks: "Remarks",
        Preference: "Preference",
        // END POS simulator

        General: 'General',
        // Cashback: 'Cashback',
        // Discount: 'Discount',
        VoucherSet: 'Voucher Set',
        Vouchers: 'Vouchers',
        Voucher_Bundle: 'Voucher Bundle',
        // Tier: 'Tier',
        Slides: 'Slides',
        Branches: 'Branches',
        Virtual_Branches: 'Virtual Branches',
        Sales_Channel: "Sales Channel",
        Physical_Branches: "Physical Branches",
        Testing_Account: "Testing Account",
        Testing_Account_Hint: "A testing branch is hidden from the dashboard and report branch lists, and its sales are excluded from \"All\".",
        Search_Name_Address: "Search by name, address",
        Export_Import: "Export / Import",
        TopUp: 'Top Up',
        // SMS: 'SMS',

        VoucherRedemption: 'Voucher Redemption',
        SlideShow: 'Slide Show',
        TopupReports: 'Topup',
        POSTransaction: 'POS Transactions',
        PaidMembership: 'Paid Membership',
        MemberVoucherReports: 'Member Voucher',
        VoidTopupReports: 'Void Topup',
        OrderItem: 'POS Order Item Report',
        PaidOnlineOrders: 'Paid Online Orders',
        PaidKioskOrders: 'Paid Kiosk Orders',
        WalletReports: 'Wallet',
        MemberBalancePointsReports: 'Member Balance Points',
        PointReports: 'Points',
        PointsBalance: 'Points Balance',
        DonationReports: 'Donation',
        WhatsAppReports: 'WhatsApp',
        WA_Template: 'WA Templates',
        WA_Marketing: 'WA Marketing',
        Campaign: 'Campaigns',
        BookingManagement: 'Booking Management',
        AppointmentCalendar: 'Appointment Calendar',
        DiscountFOC: 'Discount & FOC',
        ItemReports: 'Item Reports',
        TxnLevelReports: 'Transaction Level Reports',
        CustomReports: 'Custom Reports',

        // Report Builder (views/analytics/report-builder)
        rb_title: 'Report Builder',
        rb_intro: 'Build your own reports from the sales journal.',
        rb_new_report: 'New report',
        rb_run: 'Run',
        rb_edit: 'Edit',
        rb_duplicate: 'Duplicate',
        rb_duplicated: 'Report duplicated',
        rb_move_up: 'Move up',
        rb_move_down: 'Move down',
        rb_drag: 'Drag to reorder',
        rb_delete: 'Delete',
        rb_deleted: 'Report deleted',
        rb_delete_title: 'Delete "{name}"?',
        rb_delete_body: 'The report is removed for everyone. Files already downloaded are not affected.',
        rb_cancel: 'Cancel',
        rb_close: 'Close',
        rb_no_reports: 'No reports yet. Press New report to build one.',
        rb_desc_by: 'by {cols}',
        rb_desc_one_row: 'one total row',
        rb_desc_every_row: 'every row',
        rb_desc_filters: '{n} filter(s)',
        rb_load_failed: 'The page could not be loaded. Please refresh.',
        rb_back: 'Reports',
        rb_name_placeholder: 'Name this report',
        rb_save: 'Save',
        rb_need_name: 'Give the report a name',
        rb_fix_first: 'Fix the problems first',
        rb_save_failed: 'The report could not be saved. Please try again.',
        rb_unsaved: 'You have unsaved changes. Leave this page without saving?',
        rb_step_columns: 'Columns',
        rb_step_filters: 'Only include',
        rb_step_sort: 'Sort',
        rb_step_export: 'Download',
        rb_summary: 'Summary',
        rb_agg_none: 'None',
        rb_col_title: 'Column title',
        rb_col_format: 'Format',
        rb_format_default: 'As stored',
        rb_journal_hint: 'Item, payment and discount rows of each closed bill, in receipt order. At most 31 days per run.',
        rb_agg_sum: 'Total',
        rb_agg_avg: 'Average',
        rb_agg_min: 'Lowest',
        rb_agg_max: 'Highest',
        rb_agg_count: 'Count',
        rb_agg_count_distinct: 'Count unique',
        rb_remove: 'Remove',
        rb_no_columns: 'No columns yet. Add what you want to see, e.g. Group and Net amount.',
        rb_add_column: 'Add column',
        rb_add_filter: 'Add filter',
        rb_update_filter: 'Update filter',
        rb_sort_none: 'No particular order',
        rb_sort_asc: 'Low to high / A to Z',
        rb_sort_desc: 'High to low / Z to A',
        rb_sort_hint: 'Tip: click a column title in the preview to sort by it.',
        rb_sort_by: 'Sort by {name}',
        rb_export_header: 'Include column titles in the CSV',
        rb_err_columns: 'Pick at least one column.',
        rb_preview: 'Preview',
        rb_preview_scope: 'All branches · first 200 rows',
        rb_test_run: 'Run test again',
        rb_preview_fix: 'Fix the highlighted problems to see a preview.',
        rb_preview_empty: 'Add a column to see a preview.',
        rb_run_failed: 'The report could not be run. Please try again.',
        rb_filter_by: 'Filter by',
        rb_search_fields: 'Search fields, e.g. member, net, hour',
        rb_no_field_match: 'No field matches "{q}".',
        rb_filter_title: 'Only include rows where…',
        rb_value: 'Value',
        rb_compare_time: 'Compare date and time',
        rb_text_hint: 'Not case-sensitive. "is not" also keeps rows where the value is empty.',
        rb_op_is: 'is',
        rb_op_is_not: 'is not',
        rb_op_contains: 'contains',
        rb_op_empty: 'is empty',
        rb_op_notempty: 'is not empty',
        rb_op_on: 'is on',
        rb_op_after: 'is after',
        rb_op_on_after: 'is on or after',
        rb_op_before: 'is before',
        rb_op_on_before: 'is on or before',
        rb_grouped_by: 'Rows are grouped by {cols}, because some columns show a total or count.',
        rb_one_row: 'Every column is a summary, so the report is one row.',
        rb_truncated: 'Showing the first {n} rows. Download the CSV for more, or pick a shorter period.',
        rb_total: 'Total',
        rb_no_rows: 'No bills closed in this period match the filters. Try another period.',
        rb_period: 'Period',
        rb_preset_today: 'Today',
        rb_preset_yesterday: 'Yesterday',
        rb_preset_this_week: 'This week',
        rb_preset_this_month: 'This month',
        rb_closed_note: 'Dates are when the bill was closed (Singapore time). A bill opened before midnight and closed after it counts on the closing day.',
        rb_pick_and_run: 'Pick a period and press Run.',
        rb_rows: '{n} rows',

        // Business Insights (MEGAPOS Insights API)
        insightsSectionTitle: 'Business Insights',
        insightsSectionSubtitle: 'AI-powered tips for your business',
        insightsRefresh: 'Refresh',
        dashQuickAccess: 'Quick Access',
        dashReports: 'Leaderboards & Reports',
        dashCustomize: 'Customize',
        dashNoData: 'No data for this period',
        dashNoBaseline: 'No data for {period} to compare',
        dashNoChange: 'No change from {period}',
        eodAllHidden: 'All EOD sections are hidden. Use the settings icon to choose what to show.',
        eodTitle: 'EOD Summary',
        eodNote: 'All order sources (POS, MOO, Kiosk, Grab) of the selected branch',
        eodLoading: 'Loading...',
        eodNoData: 'No data',
        eodOperationSummary: 'Operation Summary',
        eodReceiptCount: 'Receipt Count',
        eodVoidCount: 'Void Count (bill / item)',
        eodGuest: 'Guest',
        eodGrossSales: 'Gross Sales',
        eodDiscount: 'Discount',
        eodNetSales: 'Net Sales',
        eodServiceCharge: 'Service Charge',
        eodGst: 'GST',
        eodRounding: 'Rounding',
        eodTotalSales: 'Total (Sales)',
        eodBcrs: 'Total BCRS Deposit',
        eodVoidAmount: 'Void Amount',
        eodOrderSource: 'Order Source',
        eodBills: '{count} bills',
        eodNoSales: 'No sales',
        eodVoucher: 'Voucher',
        eodPromoCode: 'Promo Code',
        eodBillDiscount: 'Bill Dis',
        eodRedemption: 'Redemption',
        eodPaymentSummary: 'Payment Summary',
        eodNoPayment: 'No payment',
        eodTotalPayments: 'Total (Payments)',
        eodZeroPayments: 'Payments with $0',
        eodTopup: 'Minty Topup Payments',
        eodNoTopup: 'No Topup',
        eodTotal: 'Total',
        eodBonus: 'Bonus',
        eodCashbackSummary: 'Member Cashback Summary',
        eodMemberBills: 'Member Bills',
        eodCashbackIssued: 'Cashback Issued',
        eodCashbackUsed: 'Cashback Used',
        eodTopupUsed: 'Top Up Used',
        eodGroupSummary: 'Group Summary',
        eodTotalQtySold: 'Total Qty Sold',
        eodNoItem: 'No item sold',
        eodTypeTotal: '{name} total',
        eodItemNote: 'Item amounts include add-ons, before bill discount.',
        eodAddOnSummary: 'Add-on Summary',
        eodQty: 'Qty',
        eodNoAddOn: 'No add-on',
        eodAddOnNote: 'Included in items.',
        insightsRetry: 'Retry',
        insightsNotAvailableTitle: 'Not available',
        insightsNotAvailable: 'This insight is not available for your account right now.',
        insightsErrorTitle: 'Something went wrong',
        insightsError: 'We could not load this insight. Please try again.',
        insightsAsOfMinAgo: '{minutes} min ago',
        // end Business Insights

        // Kitchen Display
        kdsSignInTitle: 'Sign in to use Kitchen Display',
        kdsSignInBody: 'The kitchen display runs on a signed-in device. Stock and Order stay available on this link.',
        kdsSignInAction: 'Go to sign in',
        kdsPickerTitle: 'KDS Links',
        kdsPickerCancel: 'Cancel',
        // end Kitchen Display

        // Airwallex Balance (Payments)
        airwallexBalance: {
            payoutMethod: 'PayNow (UEN)',
            colAccountId: 'Account ID',
            colCreatedAt: 'Created At',
            colPhysicalBranchName: 'Physical Branch Name',
            colPhysicalBranchId: 'Physical Branch ID',
            colTransferId: 'Transfer ID',
            colBeneficiary: 'Beneficiary',
            colAmount: 'Amount',
            colReference: 'Reference',
            colTransferStatus: 'Status',
            title: 'AIRWALLEX BALANCE',
            crumb: 'Payments › Airwallex',
            openFromPayments: 'View balance & transactions',
            account: 'Account',
            allAccounts: 'All accounts',
            merchantAccount: 'Merchant (all outlets)',
            period: 'Period',
            last30: 'Last 30 days',
            thisMonth: 'This month',
            lastMonth: 'Last month',
            past12: 'Past 12 months',
            custom: 'Custom range',
            from: 'From',
            to: 'To',
            overview: 'Overview',
            transactions: 'Transactions',
            grossSales: 'Gross sales',
            fees: 'MegaPOS fees',
            refunds: 'Refunds taken back',
            paidOut: 'Paid out',
            vsPrevious: '{change} vs previous period',
            previousAmount: '{amount} in previous period',
            feeShare: '{pct}% of gross',
            paidOutHint: 'to PayNow, daily at 06:00',
            netEarnings: 'Net earnings',
            netVsPrevious: 'vs {from} – {to} ({amount})',
            day: 'Day',
            month: 'Month',
            legendNote: 'Gross = what customers paid · MegaPOS fee = kept before the money reaches you · Net = credited to your Airwallex wallet. Only payments made through Airwallex are counted.',
            recentTransactions: 'Recent transactions',
            seeAll: 'See all',
            colDate: 'Date (SGT)',
            colType: 'Type',
            colOrder: 'Order / description',
            colMethod: 'Method',
            colStatus: 'Status',
            colGross: 'Gross',
            colFee: 'Fee',
            colNet: 'Net',
            colSettled: 'Settled (SGT)',
            walletBalance: 'Wallet balance',
            available: 'Available',
            pending: 'Pending (settles ~23:00)',
            reserve: 'Kept as reserve',
            nextPayout: 'Next payout',
            estimatedAmount: 'Estimated amount',
            noPayout: 'Nothing to pay out yet: the balance is below the {amount} reserve kept for refunds.',
            payoutNote: 'Paid out every day at 06:00 to your company\'s PayNow (UEN).',
            viewPayouts: 'View payouts',
            accounts: 'Accounts',
            notActiveNote: 'No balance until the account is active',
            accountActive: 'Active',
            accountNotActive: 'Not active yet',
            balanceUnavailable: 'Balance unavailable right now, please try again later.',
            updatedAt: 'Updated {time} · refreshed every 30 minutes from Airwallex.',
            refresh: 'Refresh',
            refreshing: 'Refreshing…',
            refreshBusy: 'An update from Airwallex is already running. Please refresh again in a minute.',
            refreshFailed: 'Could not refresh from Airwallex. Please try again.',
            notSyncedYet: 'Transactions have not been loaded from Airwallex yet.',
            reconcileMismatch: 'Our copy of the transactions does not match the Airwallex balance yet ({ledger} vs {airwallex}). It is re-checked every 30 minutes; the balance shown comes straight from Airwallex.',
            unlinked: '{count} payment(s) are still being matched to their order: gross and fees leave them out until then.',
            noAccount: 'No Airwallex account connected yet. Connect one from Payments.',
            all: 'All',
            payments: 'Payments',
            payouts: 'Payouts',
            refundsTab: 'Refunds',
            typePayment: 'Payment',
            typePayout: 'Payout',
            typeRefund: 'Refund',
            typeOther: 'Other',
            allStatuses: 'All statuses',
            statusPending: 'Pending',
            statusSettled: 'Settled',
            statusCancelled: 'Cancelled',
            statusPaid: 'Paid',
            statusTakenBack: 'Taken back',
            search: 'Search',
            searchPlaceholder: 'Order ID or Airwallex payment ID',
            exportCsv: 'Export CSV',
            empty: 'No transactions for these filters.',
            showing: 'Showing {from}–{to} of {total}',
            close: 'Close',
            breakdown: 'Breakdown',
            customerPaid: 'Customer paid',
            megaposFee: 'MegaPOS fee ({pct}%)',
            credited: 'Credited to your wallet',
            takenBack: 'Taken back from your wallet',
            timeline: 'Timeline',
            tPaid: 'Customer paid {amount}',
            tCredited: '{amount} credited to wallet (pending)',
            tSettled: 'Settled, available in wallet',
            tPaidOut: 'Paid out to PayNow (UEN)',
            tWaiting: 'Will be paid out in the next daily payout',
            openPayout: 'Open payout of {date}',
            references: 'References',
            order: 'Order',
            airwallexPayment: 'Airwallex payment',
            refundNote: 'If this order is refunded, the refunded amount is taken back from your Airwallex wallet and shows as a Refund line.',
            summary: 'Summary',
            paymentsGross: '{count} payment(s), gross',
            carriedIn: 'From earlier balance',
            carriedOut: 'Left in wallet',
            sentTo: 'Sent to',
            beneficiary: 'Beneficiary',
            reference: 'Reference',
            transferId: 'Airwallex transfer',
            includedTitle: 'Included in this payout',
            includedSince: 'Settled after the previous payout ({date}).',
            includedAll: 'Settled before this payout.',
            nothingIncluded: 'Nothing settled since the previous payout.',
            paidAt: 'Paid at (SGT)',
            walletNote: 'Account = the Airwallex wallet that received the money.',
            totalBalance: 'Total balance (all accounts)',
            statusSent: 'Sent',
            statusFailed: 'Failed',
            uncreditedBanner: '{count} paid order(s) ({amount}) have not reached your wallet yet.',
            uncreditedTitle: 'Paid but not credited',
            uncreditedNote: 'Customers paid these orders, but the money was not moved to your Airwallex wallet. MegaPOS support can settle them: send them the order IDs.',
            view: 'View',
            loadFailed: 'Could not load the Airwallex data. Please try again.'
        }
        // end Airwallex Balance
    },
    cn: {
        // sidebar
        Dashboard: "仪表",
        Setting: '设置',
        Report: '报表',
        Booking: 'Booking',
        Marketing: '推广',
        Product: '产品',
        'Loyalty Members': '会员',
        'Order Management': 'Order Management',
        // 'Payment': '支付',
        'Subscription': '订阅计划',
        'POS Simulator': '收银机模拟器',
        'Stripe Reader': 'Stripe Reader',
        // end sidebar

        // GLOBAL
        name: '姓名',
        status: '状态',
        action: '行动',
        logout: '登出',
        language: '语言',
        Type: "类型",
        Count: "计数",
        Image: "图像",
        All: "全部",
        Time: "时间",
        RUN: "执行",
        ID: "ID",
        Display_Period: "显示期",
        // END GLOBAL

        // subscription
        select: '选择',
        package: '包裹',
        price: '价格',
        nextBiling: '下一个喘息',
        dueAmount: '到期金额',
        paymentStatus: '支付状态',
        // status: '地位',
        // action: '行动',
        // end subscription

        // PAYMENT
        // name: '姓名',
        merchantCode: '商人代码',
        stripeAccount: '条纹帐户',
        accessCode: 'Access Code',
        merchantID: 'Merchant ID',
        posId: 'POS ID',
        viewPayout: '查看支付',
        // END PAYMENT

        // LOYALTY  MEMERS
        LoyaltyMemberlist: "忠诚度成员列表",
        selectTier: "选择层",
        selectGender: "选择性别",
        bulkAction: "批量行动",
        download: "下载",
        // ID: "ID",
        phoneNo: "电话号码",
        // name: "姓名",
        email: "电子邮件",
        DOB: "生日",
        gender: "性别",
        joinDate: "加入日期",
        lastPurchase: "上次购买",
        lastActive: "Last Active",
        // status: "地位",
        // action: "行动",
        // END LOYALTY  MEMERS

        // Products
        PRODUCTS_MERCHANDISES_LIST: "产品和商品清单",
        ADD_PRODUCT_MERCHANDISE: "添加产品/商品",
        // Type: "类型",
        SKU: "sku",
        // Image: "图像",
        Name: "姓名",
        Price: "价格",
        Stock: "库存",
        // status: "地位",
        // action: "行动",
        ADD_GROUP: "添加组",
        Group_ID: "组ID",
        Group_Name: "团队名字",
        Group_Description: "团体简介",
        // status: "地位",
        // action: "行动",
        // End Products

        // Marketing
        OVERALL_PERFORMANCE: "整体表现",
        Total_Rewards_Used: "总奖励使用",
        Average_Spending_per_Rewards: "平均每奖励支出",
        Total_Revenue_from_Rewards: "奖励总收入",
        REWARDS_CAMPAIGN: "奖励运动",
        // Count: "计数",
        Show: "展示",
        // All: "全部",
        Active: "积极的",
        Past: "过去的",
        Deactive: "停用",
        Campain_Title: "驻地标题",
        Rewards: "奖励",
        // Type: "类型",
        Duration: "期间",
        Email_Sent: "邮件已发送",
        SMS_Sent: "短信发送",
        Used: "用过的",
        Revenue: "收入",
        // status: "地位",
        // action: "行动",
        // end Marketing

        // slide show
        SLIDES_SHOW_REPORT: "幻灯片显示报告",
        // Time: "时间",
        // RUN: "跑步",
        // Count: "计数",
        Image_ID: "图像ID",
        Image_File: "图像文件",
        // Image: "图像",
        Who_can_see_this_image: "谁可以看到这个图像",
        // Display_Period: "显示期",
        Created_Date: "创建日期",
        Creator: "创造者",
        // status: "地位",
        EXPORT_TO_EXCEL: "导出到Excel",
        // end slide show

        // Voucher Redemption
        Voucher_Status: "凭证状态",
        // All: "All",
        Redeemable: "可赎回",
        Redeemed: "赎回",
        // Time: "Time",
        Search: "搜索",
        Voucher_Type: "优惠券类型",
        Discount_Amount: "折扣金额",
        Member_Gender: "成员性别",
        Select_gender: "选择性别",
        // download: "Download",
        // Count: "Count",
        // RUN: "RUN",
        Columns: "列",
        Row_No: "第",
        Voucher_Name: "代金券的名称",
        Voucher_Code: "优惠券代码",
        Discount: "折扣码",
        Bill_Total: "比尔总数",
        Member_Name: "成员名字",
        Member_ID: "会员ID",
        Member_Email: "会员电子邮件",
        Member_Mobile: "会员手机",
        Issue_Date: "签发日期",
        Redeem_Date: "兑换日期",
        // end Voucher Redemption

        // TOP UP
        Top_Up_Amount: "充值金额",
        Payment_Amount: "支付金额",
        Paid_Amount_Expiry: "付费到期",
        Bonus_Amount: "奖金金额",
        Bonus_Expiry: "奖金到期",
        // action: "行动",
        // END TOP UP

        // BRANCHES
        // ID: "ID",
        Branch_Name: "分店名称",
        Physical_Branch_Name: "Physical Branch Name",
        Virtual_Branch_Name: "Virtual Branch Name",
        Sale_Channel_Name: "Sale Channel Name",
        Address: "地址",
        Operating_Hours: "营业时间",
        // status: "地位",
        // action: "行动",
        // END BRANCHES

        // SLIDES
        Slider_Images: "滑块图像",
        Image_Sequence: "图像序列",
        Recommended_Size_Landing_Page: "建议尺寸：1080 × 1350 像素（4:5）",
        Recommended_Size_Banner: "建议尺寸：1200 × 600 像素（2:1）",
        Recommended_Size_Product_Image: "建议尺寸：800 × 800 像素（1:1）",
        Recommended_Size_Category_Image: "建议尺寸：400 × 400 像素（1:1）",
        Upload_image: "上传图片",
        Who_can_see_this_slide: "谁能看到这张幻灯片",
        // Display_Period: "显示期",
        From: "从",
        Always_Display: "总是显示",
        Destination_link: "目标链接（从成员门户单击映像时，用户将被定向到此链接）",
        VIP: "VIP",
        LEVEL_1: "1级",
        LEVEL_2: "级别2",
        PLATINUM: "铂",
        // END SLIDES

        // TIER
        Tier_Name: "层名 *",
        Description: "描述",
        Show_tier_description_in_member_portal: "在会员门户中显示层描述",
        Show_tier_condition_in_member_portal: "Show tier condition in member portal",
        Condition_to_achieve_tier: "实现层的条件 *",
        Share_full_profile: "共享完整的个人资料",
        Spending: "开支",
        Duration_of_membership : "会员持续时间",
        Condition_to_maintain_tier: "维持层的条件 *",
        Cashback_Rule: "现金返还规则",
        Point_Rule: "Ponit Rule",
        Standard_Rule: "标准规则",
        Superior_Rule: "上级规则",
        Welcome_Benefit: "欢迎收益",
        Voucher: "代金券",
        Direct_Cashback: "直接现金返还",
        Direct_Point: "Direct Point",
        Birthday_Benefit: "生日利益",
        Extra_Cashback: "额外的现金返还",
        Extra_Point: "Extra Point",
        SAVE : "保存",
        DELETE: "删除",
        Tier_Badge: "层徽章",
        UPLOAD_ICON: "上传图标",
        Upload_icon_minumum_150_150: "上传图标Minumum 150 x 150",
        VIP_TIER: "VIP层",
        PLATINUM_TIER: "白金层",
        save: "保存",
        delete: "删除",
        // END TIER

        // Settings - Voucher set
        // ID: "ID",
        Title: "标题",
        // Image: "图像",
        // Type: "类型",
        Exchange_Value: "交换价值",
        Total: "全部的",
        Issued: "发布",
        Sold: "Sold",
        Number_Of_Vouchers: "Number Of Vouchers",
        Total_Rev: "总复兴",
        // Used: "用过的",
        Expiry_Date: "到期日",
        // status: "地位",
        // action: "行动",
        // END Settings - Voucher set

        // Settings - Discount
        Rewards_Used: "使用的奖励",
        // Average_Spending_per_Rewards: "平均每奖励支出",
        // Total_Revenue_from_Rewards: "奖励总收入",
        // ID: "ID",
        // Title: "标题",
        Code: "代码",
        // Used: "用过的",
        // Revenue: "收入",
        // action: "行动",
        // END Settings - Discount

        // Settings - Cashback
        STANDARD_RULE: "标准规则",
        Hours: "小时",
        Pending_time_before_cashback_can_be_redeemed: "赎回现金返还之前等待时间",
        Pending_time_before_point_can_be_redeemed: "Pending time before point can be redeemed",
        Expiry_of_each_cashback_amount: "每个现金返还金额的到期",
        Expiry_of_each_point_amount: "Expiry of each point amount",
        Rebate: "回扣",
        Save: "保存",
        Delete: "删除",
        Cashback: "现金返还",
        Point: "Point",
        No_end_date: "没有结束日期",
        SUPERIOR_RULE: "上级规则",
        Rule_Name: "规则名称",
        Spend_Every: "花费每一个",
        Exchange: "Exchange",
        // END Settings - Cashback

        // Settings - General
        Merchant_Info: "商人信息",
        Merchant_ID: "商人ID",
        Merchant_Code: "商人代码",
        Company_Email: "公司电子邮件",
        Finance_Email: "财务电子邮件",
        Finance_Mobile: "财务手机",
        Contact_Infomation: "接触信息",
        Contact_Emails: "联系电子邮件",
        Free_Text: "Free Text",
        Terms_Conditions: "Terms & Conditions",
        Privacy_Policy: "Privacy Policy",
        Terms_Conditions_Donation: "Terms & Conditions(Donation)",
        Merchant_Appearance: "商人外观",
        Merchant_Logo: "商人徽标",
        Logo_Theme2: "主题2徽标",
        Main_Theme2_Color: "主题2主色",
        // KSK063 Kiosk Appearance
        Kiosk_Appearance: "外观",
        Kiosk_Appearance_Hint: "点击预览中高亮的元素以更改其颜色。",
        Kiosk_Pick_Colours: "选择颜色",
        Kiosk_Use_Kiosk: "操作自助机",
        Kiosk_Page_Landing: "首页",
        Kiosk_Page_Menu: "菜单",
        Kiosk_Page_Cart: "购物车",
        Kiosk_Page_Payment: "付款",
        Kiosk_Page_Rewards: "奖励",
        Kiosk_Custom_Colours: "自定义颜色",
        Kiosk_No_Custom_Colours: "所有元素均使用主题颜色。",
        Kiosk_Reset_All: "全部恢复为主题颜色",
        Kiosk_Use_Theme_Colour: "使用主题颜色",
        Kiosk_Set_Custom_Colour: "设置自定义颜色",
        Kiosk_Outline: "轮廓",
        Kiosk_Font: "字体",
        Kiosk_Accent: "强调色",
        Kiosk_Apply: "应用",
        Kiosk_Cancel: "取消",
        Kiosk_Unsaved: "有未保存的更改，请点击保存。",
        Kiosk_Saved: "自助机颜色已保存。",
        Kiosk_Select_Channel: "请选择销售渠道以预览其自助机。",
        Kiosk_Background_Colours: "背景颜色",
        Kiosk_Bg_Header: "页眉（点餐、购物车和付款页面）",
        Kiosk_Bg_Category: "菜单分类背景",
        Kiosk_Bg_Menu: "菜单列表背景",
        Kiosk_Bg_Default: "默认",
        Kiosk_Bg_Reset: "使用默认背景",
        Primary_Button_Color: "主按钮颜色（主题2）",
        Loyalty_App_Theme_Color: "忠诚度应用主题颜色（背景）",
        Loyalty_App_Button_Color: "忠诚度应用按钮颜色",
        Loyalty_App_Button_Text_Color: "忠诚度应用按钮文字颜色",
        Loyalty_App_Text_Header_Color: "忠诚度应用文本标题颜色",
        Member_App_Theme_Color: "会员应用主题颜色",
        Member_App_Theme_Color_Default: "默认",
        Reset_To_Default: "恢复默认",
        Member_Login_Background: "登录背景",
        Member_Login_Background_Hint: "显示在会员应用登录页的标志后面。留空则使用默认背景。",
        Member_Login_Background_Format: "png、jpg/jpeg 或 webp",
        Outlet_List_Header: "门店列表页头图",
        Outlet_List_Header_Hint: "显示在门店列表页（/physical-branch/order）顶部、门店列表上方。留空则不显示头图。",
        Recommended_Size_Outlet_List_Header: "建议尺寸：1080 × 1440 像素（3:4）",
        // UPLOAD_ICON: "上传图标",
        Upload_image_maximum_2M: "上传图像最多2m",
        Options: "选项",
        POS_Version: "POS 版本",
        Allow_set_up_membership_tiering: "允许设置会员分层",
        Visits: "Visits",
        Allows_displaying_membership_spending: "允许显示会员支出",
        Allows_displaying_lifetime_earn_cashback: "允许显示终生赚取现金返还",
        Allows_displaying_redeemed_cashback: "允许显示赎回的现金返还",
        Cashback_by_subtotal: "Calculate cashback base on subtotal",
        only_allow_existing_member_moo_login: "Only allow existing members to login",
        allow_show_apply_voucher: "Allow show apply voucher",
        automatically_extend_expired_wallet_balance_after_a_top_up: "Automatically extend expired wallet balance after a top-up",
        show_topup_button_on_home: "Show Top-up button on member Home",
        Member_donation_transaction_history: "Allow displaying member's donation in Transaction History screen",
        Otp_test_mode: "OTP测试模式",
        // Otp test mode: "OTP测试模式",
        Member_Special_Rewards: "会员特别奖励",
        Reward_per_transaction: "Reward per transaction",
        Collect_cashback_and_point: "Allow members to earn cashback/points when orders are paid by wallet",
        Profile_sharing_reward: "个人资料共享奖励（用户输入或分享商人的配置文件时发送的代金券）",
        Friend_inviting_reward: "朋友邀请奖励（用户朋友注册时发送代金券）",
        SMS_Setup: "SMS设置",
        Character_count:"角色计数",
        Notifications: "通知",
        // Notification: "通知",
        Topup: "上层",
        Deduction_From_Wallet: "从钱包中扣除",
        Earn_Cashback: "赚取现金返还",
        In_App: "应用内",
        Email: "电子邮件",
        SMS_and_WA: "短信余额 & WhatsApp",
        Airwallex_checkout_failed: "无法打开支付页面，请重试",
        Notification_Content: "通知内容",
        // Settings - General

        // POS simulator
        POS_Transaction: "POS交易",
        Update_POS_Transaction: "Update POS交易",
        Phone_Number: "电话号码",
        By_Total_Amount: "总金额",
        By_product: "通过产品",
        Total_Amount: "总金额",
        Discount_Code: "折扣码",
        // Voucher_Code: "优惠券号",
        Branch: "分行",
        Staff: "职员*",
        Deduct_from_Wallet: "从钱包中扣除",
        Payment_Amount_Topup: "支付金额",
        Top_Up: "充值金额",
        // Phone_Number: "电话号码",
        Branch_Id: "分支ID",
        // Staff: "职员",
        // Top_Up_Amount: "充值金额",
        Top_Up_Method: "充气方法",
        Cashback_Adjustment: "现金返还调整",
        // Phone_Number: "电话号码",
        // Branch_Id: "分支ID",
        // Staff: "职员",
        // Total_Amount: "总金额",
        Add_more_payment_amount: "增加更多付款金额",
        Receipt_Total: "账单总额",
        Sub_Total: "Sub Total",
        Total_Before_Tax: "Total Before Tax",
        GST: "GST",
        Cess: 'Cess',
        Service_Charge: 'Service Change',
        Take_Away_Charge: 'Take Away Charge',
        Payment: "支付",
        Wallet_Balance : "钱包余额",
        Paid_Topup: "付费充值",
        Topup_Bonus: "奖金",
        // Cashback: "返现",
        Address_1: "地址 1",
        Address_2: "地址 2",
        // Email: "电邮",
        // Name: "姓名",
        Tier: "会员等级",
        Remarks: "备注信息",
        Preference: "会员偏好",
        // END POS simulator,

        General: "通用设置",
        // Cashback: "现金返还",
        // Discount: "折扣码",
        Voucher_Bundle: 'Voucher Bundle',
        // Tier: "会员等级",
        Slides: "滑动图片",
        Branches: "分行",
        Virtual_Branches: 'Virtual Branches',
        Sales_Channel: "Sales Channel",
        Physical_Branches: "实体分店",
        Testing_Account: "测试账户",
        Testing_Account_Hint: "测试分店不会出现在仪表板和报表的分店列表中，其销售额也不计入“全部”。",
        Search_Name_Address: "按名称、地址搜索",
        Export_Import: "导出 / 导入",
        TopUp: "充值设置",
        // SMS: "短信余额",

        VoucherRedemption: "优惠券兑换",
        SlideShow: "会员页幻灯片",
        TopupReports: "充值记录",
        POSTransaction: "收银机订单",
        PaidMembership: 'Paid Membership',
        MemberVoucherReports: 'Member Voucher',
        VoidTopupReports: 'Void Topup',
        OrderItem: 'POS Order Item Report',
        PaidOnlineOrders: 'Paid Online Orders',
        PaidKioskOrders: 'Paid Kiosk Orders',
        WalletReports: 'Wallet',
        MemberBalancePointsReports: 'Member Balance Points',
        PointReports: 'Points',
        PointsBalance: 'Points Balance',
        DonationReports: 'Donation',
        WhatsAppReports: 'WhatsApp',
        WA_Template: 'WA Templates',
        WA_Marketing: 'WA Marketing',
        Campaign: 'Campaigns',
        BookingManagement: 'Booking Management',
        AppointmentCalendar: 'Appointment Calendar',
        DiscountFOC: 'Discount & FOC',
        ItemReports: 'Item Reports',
        TxnLevelReports: 'Transaction Level Reports',
        CustomReports: 'Custom Reports',

        // Report Builder (views/analytics/report-builder)
        rb_title: '报表生成器',
        rb_intro: '基于销售流水自定义报表。',
        rb_new_report: '新建报表',
        rb_run: '运行',
        rb_edit: '编辑',
        rb_duplicate: '复制',
        rb_duplicated: '报表已复制',
        rb_move_up: '上移',
        rb_move_down: '下移',
        rb_drag: '拖动以排序',
        rb_delete: '删除',
        rb_deleted: '报表已删除',
        rb_delete_title: '删除“{name}”？',
        rb_delete_body: '所有人都将无法再使用该报表。已下载的文件不受影响。',
        rb_cancel: '取消',
        rb_close: '关闭',
        rb_no_reports: '还没有报表。点击“新建报表”创建。',
        rb_desc_by: '按 {cols}',
        rb_desc_one_row: '单行合计',
        rb_desc_every_row: '全部明细',
        rb_desc_filters: '{n} 个筛选',
        rb_load_failed: '页面加载失败，请刷新。',
        rb_back: '报表',
        rb_name_placeholder: '报表名称',
        rb_save: '保存',
        rb_need_name: '请填写报表名称',
        rb_fix_first: '请先修正问题',
        rb_save_failed: '报表保存失败，请重试。',
        rb_unsaved: '有未保存的更改，确定离开此页面吗？',
        rb_step_columns: '列',
        rb_step_filters: '只包含',
        rb_step_sort: '排序',
        rb_step_export: '下载',
        rb_summary: '汇总',
        rb_agg_none: '无',
        rb_col_title: '列标题',
        rb_col_format: '格式',
        rb_format_default: '按原样',
        rb_journal_hint: '每张已结账单的商品、付款和折扣行，按收据顺序。每次最多 31 天。',
        rb_agg_sum: '合计',
        rb_agg_avg: '平均',
        rb_agg_min: '最低',
        rb_agg_max: '最高',
        rb_agg_count: '计数',
        rb_agg_count_distinct: '不同值计数',
        rb_remove: '移除',
        rb_no_columns: '还没有列。添加想查看的内容，例如“Group”和“Net amount”。',
        rb_add_column: '添加列',
        rb_add_filter: '添加筛选',
        rb_update_filter: '更新筛选',
        rb_sort_none: '不排序',
        rb_sort_asc: '从低到高 / A 到 Z',
        rb_sort_desc: '从高到低 / Z 到 A',
        rb_sort_hint: '提示：点击预览中的列标题即可按该列排序。',
        rb_sort_by: '按 {name} 排序',
        rb_export_header: 'CSV 包含列标题',
        rb_err_columns: 'Pick at least one column.',
        rb_preview: '预览',
        rb_preview_scope: '所有分店 · 前 200 行',
        rb_test_run: '重新测试',
        rb_preview_fix: '请修正标出的问题以查看预览。',
        rb_preview_empty: '添加列以查看预览。',
        rb_run_failed: '报表运行失败，请重试。',
        rb_filter_by: '筛选字段',
        rb_search_fields: '搜索字段，例如 member、net、hour',
        rb_no_field_match: '没有匹配“{q}”的字段。',
        rb_filter_title: '只包含满足以下条件的行…',
        rb_value: '值',
        rb_compare_time: '比较日期和时间',
        rb_text_hint: '不区分大小写。“不是”也会保留值为空的行。',
        rb_op_is: '是',
        rb_op_is_not: '不是',
        rb_op_contains: '包含',
        rb_op_empty: '为空',
        rb_op_notempty: '不为空',
        rb_op_on: '在',
        rb_op_after: '晚于',
        rb_op_on_after: '在或晚于',
        rb_op_before: '早于',
        rb_op_on_before: '在或早于',
        rb_grouped_by: '因部分列为合计或计数，行已按 {cols} 分组。',
        rb_one_row: '所有列都是汇总，因此报表只有一行。',
        rb_truncated: '仅显示前 {n} 行。下载 CSV 查看更多，或选择更短的时间段。',
        rb_total: '合计',
        rb_no_rows: '该时间段内没有符合筛选条件的已结账单。请换一个时间段。',
        rb_period: '时间段',
        rb_preset_today: '今天',
        rb_preset_yesterday: '昨天',
        rb_preset_this_week: '本周',
        rb_preset_this_month: '本月',
        rb_closed_note: '日期按账单结账时间（新加坡时间）计算。午夜前开单、午夜后结账的账单计入结账当天。',
        rb_pick_and_run: '选择时间段后点击运行。',
        rb_rows: '{n} 行',

        // Business Insights (MEGAPOS Insights API)
        insightsSectionTitle: '商业洞察',
        insightsSectionSubtitle: 'AI 智能经营建议',
        insightsRefresh: '刷新',
        dashQuickAccess: '快捷入口',
        dashReports: '排行榜与报表',
        dashCustomize: '自定义',
        dashNoData: '此期间暂无数据',
        dashNoBaseline: '{period}无数据可对比',
        dashNoChange: '与{period}持平',
        eodAllHidden: '所有 EOD 版块已隐藏，请点击设置图标选择显示内容。',
        eodTitle: 'EOD 汇总',
        eodNote: '所选分店的所有订单来源（POS、MOO、Kiosk、Grab）',
        eodLoading: '加载中...',
        eodNoData: '暂无数据',
        eodOperationSummary: '营业汇总',
        eodReceiptCount: '单据数',
        eodVoidCount: '作废数（单 / 品项）',
        eodGuest: '人数',
        eodGrossSales: '总销售额',
        eodDiscount: '折扣',
        eodNetSales: '净销售额',
        eodServiceCharge: '服务费',
        eodGst: '消费税',
        eodRounding: '凑整',
        eodTotalSales: '合计（销售）',
        eodBcrs: 'BCRS 押金合计',
        eodVoidAmount: '作废金额',
        eodOrderSource: '订单来源',
        eodBills: '{count} 单',
        eodNoSales: '无销售',
        eodVoucher: '礼券',
        eodPromoCode: '优惠码',
        eodBillDiscount: '整单折扣',
        eodRedemption: '钱包抵扣',
        eodPaymentSummary: '付款汇总',
        eodNoPayment: '无付款',
        eodTotalPayments: '合计（付款）',
        eodZeroPayments: '零金额付款方式',
        eodTopup: 'Minty 充值',
        eodNoTopup: '无充值',
        eodTotal: '合计',
        eodBonus: '赠送',
        eodCashbackSummary: '会员返现汇总',
        eodMemberBills: '会员单数',
        eodCashbackIssued: '返现发放',
        eodCashbackUsed: '返现使用',
        eodTopupUsed: '储值使用',
        eodGroupSummary: '分组汇总',
        eodTotalQtySold: '销售总数量',
        eodNoItem: '无销售品项',
        eodTypeTotal: '{name} 合计',
        eodItemNote: '品项金额含加料，未扣整单折扣。',
        eodAddOnSummary: '加料汇总',
        eodQty: '数量',
        eodNoAddOn: '无加料',
        eodAddOnNote: '已含在品项金额中。',
        insightsRetry: '重试',
        insightsNotAvailableTitle: '暂不可用',
        insightsNotAvailable: '您的账户暂时无法查看此项洞察。',
        insightsErrorTitle: '出现错误',
        insightsError: '无法加载此项洞察，请重试。',
        insightsAsOfMinAgo: '{minutes} 分钟前',
        // end Business Insights

        // Kitchen Display
        kdsSignInTitle: '登录后使用厨房显示屏',
        kdsSignInBody: '厨房显示屏需在已登录的设备上运行。此链接的库存与订单页仍可正常使用。',
        kdsSignInAction: '前往登录',
        kdsPickerTitle: 'KDS 链接',
        kdsPickerCancel: '取消',
        // end Kitchen Display

        // Airwallex Balance (Payments)
        airwallexBalance: {
            payoutMethod: 'PayNow (UEN)',
            colAccountId: '账户 ID',
            colCreatedAt: '创建时间',
            colPhysicalBranchName: '实体分店名称',
            colPhysicalBranchId: '实体分店 ID',
            colTransferId: '转账 ID',
            colBeneficiary: '收款人',
            colAmount: '金额',
            colReference: '参考号',
            colTransferStatus: '状态',
            title: 'AIRWALLEX 余额',
            crumb: '支付 › Airwallex',
            openFromPayments: '查看余额与交易',
            account: '账户',
            allAccounts: '全部账户',
            merchantAccount: '商户（全部门店）',
            period: '期间',
            last30: '最近 30 天',
            thisMonth: '本月',
            lastMonth: '上月',
            past12: '过去 12 个月',
            custom: '自定义范围',
            from: '从',
            to: '至',
            overview: '概览',
            transactions: '交易',
            grossSales: '总销售额',
            fees: 'MegaPOS 手续费',
            refunds: '退款扣回',
            paidOut: '已付款',
            vsPrevious: '较上期 {change}',
            previousAmount: '上期 {amount}',
            feeShare: '占总额 {pct}%',
            paidOutHint: '每天 06:00 付至 PayNow',
            netEarnings: '净收入',
            netVsPrevious: '对比 {from} – {to}（{amount}）',
            day: '日',
            month: '月',
            legendNote: '总额 = 顾客支付金额 · MegaPOS 手续费 = 款项到账前扣除 · 净额 = 存入您的 Airwallex 钱包。仅统计通过 Airwallex 的付款。',
            recentTransactions: '最近交易',
            seeAll: '查看全部',
            colDate: '日期（新加坡时间）',
            colType: '类型',
            colOrder: '订单 / 说明',
            colMethod: '方式',
            colStatus: '状态',
            colGross: '总额',
            colFee: '手续费',
            colNet: '净额',
            colSettled: '结算时间（新加坡时间）',
            walletBalance: '钱包余额',
            available: '可用',
            pending: '待结算（约 23:00 结算）',
            reserve: '保留金额',
            nextPayout: '下次付款',
            estimatedAmount: '预计金额',
            noPayout: '暂无可付款项：余额低于为退款保留的 {amount}。',
            payoutNote: '每天 06:00 付至贵公司的 PayNow (UEN)。',
            viewPayouts: '查看付款记录',
            accounts: '账户',
            notActiveNote: '账户启用前没有余额',
            accountActive: '已启用',
            accountNotActive: '尚未启用',
            balanceUnavailable: '暂时无法获取余额，请稍后再试。',
            updatedAt: '更新于 {time} · 每 30 分钟从 Airwallex 刷新。',
            refresh: '刷新',
            refreshing: '刷新中…',
            refreshBusy: '正在从 Airwallex 更新，请一分钟后再刷新。',
            refreshFailed: '无法从 Airwallex 刷新，请稍后再试。',
            notSyncedYet: '尚未从 Airwallex 载入交易。',
            reconcileMismatch: '交易记录与 Airwallex 余额暂不一致（{ledger} 对 {airwallex}）。系统每 30 分钟重新核对；显示的余额直接来自 Airwallex。',
            unlinked: '有 {count} 笔付款仍在匹配订单：在此之前总额与手续费不包含这些付款。',
            noAccount: '尚未连接 Airwallex 账户，请在“支付”页面连接。',
            all: '全部',
            payments: '收款',
            payouts: '付款',
            refundsTab: '退款',
            typePayment: '收款',
            typePayout: '付款',
            typeRefund: '退款',
            typeOther: '其他',
            allStatuses: '全部状态',
            statusPending: '待结算',
            statusSettled: '已结算',
            statusCancelled: '已取消',
            statusPaid: '已付款',
            statusTakenBack: '已扣回',
            search: '搜索',
            searchPlaceholder: '订单号或 Airwallex 付款 ID',
            exportCsv: '导出 CSV',
            empty: '没有符合条件的交易。',
            showing: '显示第 {from}–{to} 条，共 {total} 条',
            close: '关闭',
            breakdown: '明细',
            customerPaid: '顾客支付',
            megaposFee: 'MegaPOS 手续费（{pct}%）',
            credited: '存入您的钱包',
            takenBack: '从您的钱包扣回',
            timeline: '时间线',
            tPaid: '顾客支付 {amount}',
            tCredited: '{amount} 存入钱包（待结算）',
            tSettled: '已结算，可在钱包使用',
            tPaidOut: '已付至 PayNow (UEN)',
            tWaiting: '将在下一次每日付款中付出',
            openPayout: '打开 {date} 的付款',
            references: '参考',
            order: '订单',
            airwallexPayment: 'Airwallex 付款',
            refundNote: '若此订单退款，退款金额将从您的 Airwallex 钱包扣回，并显示为退款记录。',
            summary: '汇总',
            paymentsGross: '{count} 笔收款，总额',
            carriedIn: '来自之前余额',
            carriedOut: '留在钱包',
            sentTo: '收款方',
            beneficiary: '收款人',
            reference: '参考号',
            transferId: 'Airwallex 转账',
            includedTitle: '本次付款包含',
            includedSince: '上次付款（{date}）之后结算。',
            includedAll: '本次付款之前结算。',
            nothingIncluded: '上次付款后没有新的结算。',
            paidAt: '支付时间（新加坡时间）',
            walletNote: '账户 = 收款的 Airwallex 钱包。',
            totalBalance: '总余额（全部账户）',
            statusSent: '已发出',
            statusFailed: '失败',
            uncreditedBanner: '有 {count} 笔已付款订单（{amount}）尚未存入您的钱包。',
            uncreditedTitle: '已付款但未入账',
            uncreditedNote: '顾客已支付这些订单，但款项未转入您的 Airwallex 钱包。请将订单号提供给 MegaPOS 客服处理。',
            view: '查看',
            loadFailed: '无法载入 Airwallex 数据，请稍后再试。'
        }
        // end Airwallex Balance
    }
}